import React from 'react';
import { WizardData, AGENT_PURPOSES } from '../types';

interface BasicInfoStepProps {
  data: WizardData;
  updateData: (updates: Partial<WizardData>) => void;
  onNext: () => void;
}

const BasicInfoStep: React.FC<BasicInfoStepProps> = ({ data, updateData, onNext }) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (data.purpose) {
      onNext();
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-8">
      {/* Agent Purpose */}
      <div>
        <label className="block text-xl font-semibold text-white mb-2">
          Use case
        </label>
        <p className="text-gray-400 mb-6">What will your agent help with?</p>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {AGENT_PURPOSES.map((purpose) => (
            <button
              key={purpose.value}
              type="button"
              onClick={() => updateData({ purpose: purpose.value })}
              className={`
                p-6 rounded-lg border transition-all duration-200 flex flex-col items-center text-center
                ${data.purpose === purpose.value
                  ? 'border-blue-500 bg-blue-500/10 text-white'
                  : 'border-gray-700 bg-gray-800/50 text-gray-300 hover:border-gray-600 hover:bg-gray-800'
                }
              `}
            >
              <div className="text-3xl mb-3">{purpose.icon}</div>
              <div className="text-sm font-medium leading-tight">{purpose.label}</div>
            </button>
          ))}
        </div>
        {data.purpose === 'other' && (
          <div className="mt-4">
            <input
              type="text"
              className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Describe your specific use case"
            />
          </div>
        )}
      </div>



      {/* Navigation */}
      <div className="flex justify-end pt-6">
        <button
          type="submit"
          disabled={!data.purpose}
          className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-3 rounded-xl transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-blue-600"
        >
          Next Step →
        </button>
      </div>
    </form>
  );
};

export default BasicInfoStep;